module.exports = __webpack_public_path__ + "static/media/bxl-facebook.3ca5d200.svg";